import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ISendPushCampaignV1Body } from './send-push-campaign-v1-request';
import type { ISendPushCampaignV1Response } from './send-push-campaign-v1-response';
import { sendPushCampaignV1ResponseSchema } from './send-push-campaign-v1-response';

export async function sendPushCampaignV1Api(
  body: ISendPushCampaignV1Body,
): Promise<IValidatedResponse<ISendPushCampaignV1Response>> {
  return postRequest<ISendPushCampaignV1Response>({
    path: '/sys/notifications/v1/send',
    body,
    schema: sendPushCampaignV1ResponseSchema,
  });
}
